








import {Component, Vue} from "vue-property-decorator";
import LoadSpinner from "@/resources/components/LoadSpinner.vue";

@Component({
    components: {
        "load-spinner": LoadSpinner
    }
})
export default class LoadingOverlay extends Vue {
    get show(): boolean {
        return this.$parent.isInProgress;
    }

    mounted() {
        this.$root.$el.append(this.$el);
    }
}
